<template>


  <v-form
    ref="frmAppointment"
    v-model="isValid"
  >

    <v-card-subtitle
      class="pa-0 ma-0"
    >
      Add Personal Coverage
    </v-card-subtitle>

    <v-container
      class="pa-0 ma-0 " 
      style="height: 500px"               
      >        


        <v-row
          class="ma-0 pa-0 pt-5" 
        >
          <v-col cols="6"
              class="pa-0 ma-0"
          >

            <ycmd-provider-search
              :providerSearchSelected.sync="coverer"
              :includeGroupHeaders="true"
              :roles="['provider']"
              label="Providing Coverage"
              backgroundColor="ycmd-very-lightest-gray"
              :rules="requiredRules"

            />      
          </v-col>
          <v-col cols="6"
              class="pa-0 ma-0 pl-1"
          >
            <ycmd-provider-search
              :providerSearchSelected.sync="coveree"
              :includeGroupHeaders="false"
              :group_id="group_id"
              :roles="['provider']"
              label="Being Covered"
              backgroundColor="ycmd-very-lightest-gray"
              :rules="requiredRules"              
            />      
          </v-col>          
        </v-row>

        <v-row
          class="ma-0 pa-0 pt-5" 
        >
          <v-col cols="6"
              class="pa-0 ma-0"
          >
            <filter-select
              :pod_id="pod ? pod.id: null"
              :filters="filterItems"
              :group_id="group_id"
              :filter_id="localFilterId"
              :rules="requiredRules"              
              label="Filter"
              @change="saveFilter"
              backgroundColor="ycmd-very-lightest-gray" 
            />
          </v-col>
        </v-row>
        <v-row
          class="ma-0 pa-0 pt-5" 
        >
          <v-col cols="12"
              class="pa-0 ma-0"
          >
                <label 
                  class="v-label v-label--active theme--light fs-10 pointer"

                >The date and time the coverage starts</label>

          </v-col>
        </v-row>

        <v-row
          class="ma-0 pa-0" 
        >

          <v-col cols="3"
              class="pa-0 ma-0"
          >
            <date-picker
                v-model="localStartDate"
                :includeCustomIcon="false"
                :keyx="`appt_`"
                backgroundColor="ycmd-very-lightest-gray"
                iconStyle="inner"
                :rules="requiredRules"
                label="Start Date"
            />   
          </v-col>
          <v-col cols="3"
              class="pa-0 ma-0"
          >
            <time-entry
              v-model="localStartTime"
              backgroundColor="ycmd-very-lightest-gray"
              :rules="requiredRules"
              label="Start Time"
              class="pl-1"
            />
          </v-col>

        </v-row>    
        <v-row
          class="ma-0 pa-0 pt-5" 
        >
          <v-col cols="12"
              class="pa-0 ma-0"
          >
                <label 
                  class="v-label v-label--active theme--light fs-10 pointer"

                >The date and time the coverage ends</label>

          </v-col>
        </v-row>              

        <v-row
          class="ma-0 pa-0" 
        >
          <v-col cols="3"
              class="pa-0 ma-0"
          >
          
            <date-picker
                v-model="localEndDate"
                :includeCustomIcon="false"
                :keyx="`appt_`"
                backgroundColor="ycmd-very-lightest-gray"
                iconStyle="inner"
                :rules="requiredRules"
                label="End Date"
                :errorMessages="startEndErrorMessages"
            />       
          </v-col>
          <v-col cols="3"
              class="pa-0 ma-0"
          >
            <time-entry
              v-model="localEndTime"
              backgroundColor="ycmd-very-lightest-gray"
              :rules="requiredRules"
              label="End Time"
              class="pl-1"
            />
          </v-col>    
                            
        </v-row>


    </v-container>
  </v-form>
            
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import scheduleFilterSelect from '@/views/apps/scheduling-new/components/scheduleFilterSelect';
import timeEntry from '@/components/datetime/time-entry';
import YCMDProviderSearch from '@/components/searches/ycmd-provider';
import DatePicker from '@/components/datetime/date-picker';

  export default {
    props: {
      personalCoverage: {
          type: Object,
          default: () => {}
      },    
      filters: {
          type: Array,
          default: () => []
      },   
      group_id: {
          type: String,
          default: ''
      },  
      reload: {
          type: String,
          default: ''
      },      
      pod: {
          type: Object,
          default: () => {}
      },                             
    },
    components: {
      'time-entry': timeEntry,
      'filter-select':scheduleFilterSelect,
      'ycmd-provider-search': YCMDProviderSearch,
      'date-picker': DatePicker,
    },    
    data: () => ({
      name: '',
      rules: {
          required: value => !!value || 'Required.',
          arrayRequired: (value) => {
            return !value ||  !value.length ? 'Required.' : true
          }
      },
      isValid: true,
      localStartDate: null,
      localEndDate: null,
      localStartTime: '',
      localEndTime: '',
      localFilterId: '',
      initializing: false,
      validation_rules: {
        required: value => !!value || 'Required.',
      },
      coverer: null,
      coveree: null
     }),
    mounted() {
      this.clearValues()
    },
    methods: {
      saveFilter(params) {

        this.localFilterId = params.filter_id
      },      
      clearValues () {
        this.localStartDate = null
        this.localEndDate = null
        this.localStartTime = ''
        this.localEndTime = '',
        this.localFilterId = ''

        this.coverer = null
        this.coveree = null
      },
 
      cancel() {
        this.$emit('cancel')
      },
      save() {
        this.$emit('save')
      },

      sendChanged(params) {
        if (!this.initializing) {
          this.$emit('changed', params)
        }
      },

    },
    computed: {
      requiredRules () {
        return [this.validation_rules.required]
      },

      filterItems () {
        let sorted = this.filters.sort( (a,b) => {
            return a.name.localeCompare(b.name)
        })

        return sorted

      },
      requiredRules () {
        return [this.rules.required]
      },      
      startEndErrorMessages () {
        if (this.localStartDate && this.localEndDate && this.localStartTime && this.localEndTime) {
          let start = `${this.localStartDate}_${this.localStartTime}`
          let end = `${this.localEndDate}_${this.localEndTime}`
          if (start >= end) {
            return ['Start date and time must be before End date and time']
          }
        }
      }        
    },
    watch: {

      reload (newValue, oldValue) {
      },
    
      localStartDate (newValue, oldValue) {
        console.log('in local start', newValue)
        this.sendChanged( {
          startDate: newValue
        })
      },
      localEndDate (newValue, oldValue) {
        
        this.sendChanged( {
          endDate: newValue
        })
      },
      localFilterId (newValue, oldValue) {
        
        this.sendChanged( {
          filter: newValue
        })
      },
      localStartTime (newValue, oldValue) {
        
        this.sendChanged( {
          startTime: newValue
        })
      },
      localEndTime (newValue, oldValue) {
        
        this.sendChanged( {
          endTime: newValue
        })
      },
      coverer (newValue, oldValue) {
        
        this.sendChanged( {
          coverer: newValue ? newValue.id : null
        })
      },      
      coveree (newValue, oldValue) {
        
        this.sendChanged( {
          coveree: newValue ? newValue.id : null
        })
      },      
      
    }
  }
</script>

